import React, { useEffect, useState } from 'react';
import axios from 'axios';
import JobCard from './JobCard';
import { useSearch } from '../../hooks/SearchContext';
import Search from '../HomePage/Search'; // Assuming Search is in this location
import { BsSortUp } from "react-icons/bs";


const AllJobsPage = () => {
    const [jobs, setJobs] = useState([]);
    const [filteredJobs, setFilteredJobs] = useState([]);
    const [filters, setFilters] = useState({
        category: [],
        locationType: [],
        experienceLevel: [],
        salaryRange: [],
    });
    const { search } = useSearch();
    const [sortOrder, setSortOrder] = useState("latest");


    useEffect(() => {
        window.scrollTo(0, 0);

        const getJobs = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/jobs/getalljobs`);
                setJobs(response.data);
            } catch (error) {
                console.error('There was an error getting the jobs!', error);
            }
        };

        getJobs();
    }, []);

    const handleCheckboxChange = (filterType, value) => {
        setFilters((prev) => {
            const updatedFilters = { ...prev };
            if (updatedFilters[filterType].includes(value)) {
                updatedFilters[filterType] = updatedFilters[filterType].filter((item) => item !== value);
            } else {
                updatedFilters[filterType] = [...updatedFilters[filterType], value];
            }
            return updatedFilters;
        });
    };

    useEffect(() => {
        let filtered = jobs;

        Object.keys(filters).forEach((key) => {
            if (filters[key].length > 0) {
                filtered = filtered.filter((job) => filters[key].includes(job[key]));
            }
        });

        // Convert the jobTitle input into an array of keywords
        const jobTitles = search.jobTitle
            .split(',')
            .map(title => title.trim().toLowerCase())
            .filter(title => title.length > 0); // Remove empty entries

        // Filter Jobs based on Search
        filtered = filtered.filter((job) => {
            const jobMatches = jobTitles.some(title =>
                job.title.toLowerCase().includes(title) ||
                job.category.toLowerCase().includes(title) ||
                job.responsibilities.toLowerCase().includes(title) ||
                job.description.toLowerCase().includes(title) ||
                job.department.toLowerCase().includes(title)
            );

            const locationMatches = job.location.toLowerCase().includes(search.location.toLowerCase());

            return jobTitles.length === 0 || jobMatches &&
                (search.location.length === 0 || locationMatches);

        });


        // Apply Sorting
        if (sortOrder === "latest") {
            filtered = filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        } else if (sortOrder === "earliest") {
            filtered = filtered.sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt));
        }

        setFilteredJobs(filtered);
    }, [filters, jobs, search, sortOrder]);

    return (
        <div className="bigscreen px-16 pt-3 pb-16">
            <Search />
            <div className="flex gap-10 mt-10 items-start">
                <div className="flex flex-col gap-6 w-full max-w-[280px] p-6 bg-white rounded-[20px] shadow text-sm">
                    <h2 className="text-lg font-semibold">Filters</h2>
                    <div>
                        <h3 className="font-medium">Category</h3>
                        {['Contract', 'Full-Time', 'Freelance'].map((category) => (
                            <label key={category} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.category.includes(category)}
                                    onChange={() => handleCheckboxChange('category', category)}
                                />
                                <span>{category}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Location Type</h3>
                        {['Remote', 'Hybrid', 'In-office'].map((location) => (
                            <label key={location} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.locationType.includes(location)}
                                    onChange={() => handleCheckboxChange('locationType', location)}
                                />
                                <span>{location}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Experience Level</h3>
                        {['Entry Level', 'Mid Level', 'Senior Level'].map((level) => (
                            <label key={level} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.experienceLevel.includes(level)}
                                    onChange={() => handleCheckboxChange('experienceLevel', level)}
                                />
                                <span>{level}</span>
                            </label>
                        ))}
                    </div>
                    <div>
                        <h3 className="font-medium">Salary Range</h3>
                        {['<3 LPA', '3-5 LPA', '5-10 LPA'].map((range) => (
                            <label key={range} className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    checked={filters.salaryRange.includes(range)}
                                    onChange={() => handleCheckboxChange('salaryRange', range)}
                                />
                                <span>{range}</span>
                            </label>
                        ))}
                    </div>
                </div>


                <div className="flex flex-col gap-6 w-full p-6 rounded-[20px] shadow bg-[#F0EAEA8A]">

                    <div className='flex justify-between items-center'>
                        <h2 className="text-lg font-semibold">Jobs</h2>

                        <div className='flex items-center cursor-pointer'>
                            <BsSortUp className='text-black' />

                            <select className='bg-transparent border-none outline-none min-w-[80px] px-2 cursor-pointer'
                                onChange={(e) => setSortOrder(e.target.value)}
                                value={sortOrder}
                            >
                                {/* <option value="">Sort</option> */}
                                <option value="latest">Latest First</option>
                                <option value="earliest">Earliest First</option>
                            </select>
                        </div>

                    </div>

                    <div className="flex flex-wrap gap-6 w-full">

                        {filteredJobs.length > 0 && filteredJobs.map((job) => <JobCard key={job._id} job={job} />)}
                    </div>
                </div>


            </div>
        </div>
    );
};

export default AllJobsPage;
